export * from './src/loyalty-v1-loyalty-earning-rule-earning-rules.universal.js';
